import React, { useState, useEffect } from "react";
import axios from "axios";
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import "./style.css";

import {
  Typography, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Dialog, DialogTitle,
  DialogContent, DialogActions, Button, TextField, Divider,
  Box, Chip, FormControl, InputLabel, Select, MenuItem,
  RadioGroup, Radio, FormControlLabel, Checkbox
} from "@mui/material";

// For multi-select
import Autocomplete from '@mui/material/Autocomplete';

// For MUI date/time pickers
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';

import LeftMenu from "../../components/left-menu/index.js";

// ============= GRADE CARDS with ID -> SCORE mapping =============
const gradeOptions = [
  { id: 'card1', emoji: '🤔', text: 'Belum tau / Masih belum dibalas', score: 0 },
  { id: 'card2', emoji: '😊', text: 'Mungkin ada Potensi', score: 5 },
  { id: 'card5', emoji: '📍', text: 'Lokasi Tidak Sesuai', score: -2 },
  { id: 'card6', emoji: '📦', text: 'Produk Tidak Sesuai', score: -2 },
  { id: 'card7', emoji: '💸', text: 'Harga Tidak Sesuai', score: 3 },
  { id: 'card8', emoji: '🤬', text: 'Spam / Penipuan', score: -5 },
  { id: 'card9', emoji: '👻', text: 'Sudah 2-3X FU tidak pernah Respon Lagi', score: -1 },
];

// ============= API Calls =============
async function readEmpty() {
  try {
    // Filter out items where Stage1 === true, for example
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/stage1todo`);
    console.log("yes")
    return response.data; // { success: true, data: [...] }
  } catch (error) {
    console.error("Error fetching data2:", error);
    console.error("🛑 Axios error.toJSON():", error.toJSON());
    console.error("🛑 error.request (XHR):", error.request);
    console.error("🛑 error.response:", error.response);
    throw error;
  }
}



async function updateStage1(payload) {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}/updateStage1`,
      payload
    );
    return response.data; // { success: true, data: updatedDoc }
  } catch (error) {
    console.error("Error updating stage1:", error);
    throw error;
  }
}

// ----------------- HELPER FUNCTIONS -----------------
// These functions check if ticketData exists and return the proper field.
function getName(row) {
  if (row.ticketData && row.ticketData.length > 0) {
    return row.Nama || "N/A";
  }
  return row.Nama || "N/A";
}

function getPhone(row) {
  if (row.ticketData && row.ticketData.length > 0) {
    return row.Phone || "N/A";
  }
  return row.Phone || "N/A";
}

function getIklan(row) {
  if (row.ticketData && row.ticketData.length > 0) {
    // If the ticket record contains an Iklan field, use it; otherwise fallback to inquiry's Iklan.
    return row.ticketData[0].Iklan || row.Iklan || "N/A";
  }
  return row.Iklan || "N/A";
}

export default function LegalProcess() {
  const nowstate = useSelector(state => state);
  const navigate = useNavigate();

  // Hard-coded options
  const [names] = useState([
    "Instagram/Facebook Ads",
    "Google Ads (LiveChat)",
    "Google Ads (WhatsApp)",
    "Partner",
    "Kenalan",
    "Ga Tau",
    "OLX"
  ]);
  const [produk] = useState([
    "Virtual Office",
    "Private Office",
    "Meeting Room Kecil",
    "Meeting Room Besar (Event Room)",
    "Pendirian PT",
    "Pendirian CV",
    "Izin Khusus",
    "PKP",
    "Pajak",
    "Akutansi",
    "Website",
    "Merek"
  ]);
  const [lokasi] = useState([
    "Jakarta Selatan",
    "Jakarta Barat",
    "Jakarta Pusat",
    "Jakarta Utara",
    "Jakarta Timur",
    "Tangerang",
    "Bekasi",
    "Bali",
    "Surabaya",
    "Depok",
    "Kalimantan"
  ]);
  const [salesList] = useState(["Sales1", "Dinda", "Diva"]);
  const [adCodes, setAdCodes] = useState([]); 

  async function fetchAdCodes() {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/listAdCodes`);
      // Expecting: { success: true, data: [ ... distinct codes ... ] }
      if (response.data.success) {
        setAdCodes(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching adCodes:", err);
    }
  }

  // Table data
  const [inquiries, setInquiries] = useState([]);

  // Dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  // This object holds *all* fields we might edit or display
  const [formData, setFormData] = useState({});

  // Whether or not we are editing the "Previous Data" section
  const [editMode, setEditMode] = useState(false);

  // Backup for "previous data" if user cancels edit
  const [backupData, setBackupData] = useState({});

  useEffect(() => {
    fetchData();
    fetchAdCodes();
    fetchSalesCounts();
  }, []);

  const [salesCounts, setSalesCounts] = useState({});
  async function fetchSalesCounts() {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/salesCounts`);
      if (response.data.success) {
        console.log(response.data.data)
        setSalesCounts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching sales counts:", error);
    }
  }

  async function fetchData() {
    try {
      const res = await readEmpty();
      if (res.success) {
        setInquiries(res.data);
      }
    } catch (err) {
      console.error("Error in readEmpty:", err);
    }
  }

  // Helper to show date in the table
  const formatDisplayDate = (dateString) => {
    if (!dateString) return "N/A";
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return "N/A";
    return d.toLocaleString();
  };

  // Color a row green if Stage1 is "true"
  const getRowStyle = (row) => {
    if (row.ticketData && row.ticketData.length > 0) {
      if (row.ticketData[0].Stage1 === "true") {
        return { backgroundColor: 'lightgreen' };
      }
    }else{
    if (row.Stage1 === "true") {
      return { backgroundColor: 'lightgreen' };
    }
    return {};
  }
  };

  const handleRowClick = (row) => {
    console.log(row)
    setSelectedRowId(row._id);

    // Convert row.InqDate to Date if valid
    let inqDateVal = null;
    if (row.InqDate) {
      const dt = new Date(row.InqDate);
      if (!isNaN(dt.getTime())) {
        inqDateVal = dt;
      }
    }
    // Default followUpDate to now
    const now = new Date();

    // Use the helper functions to get the correct values
    const newForm = {
      // “previous data”
      InqDate: inqDateVal,
      Nama: getName(row),
      Iklan: getIklan(row),
      Phone: getPhone(row),
      // Ensure these are arrays
      ProdukInterest: Array.isArray(row.ProdukInterest) ? row.ProdukInterest : [],
      LokasiInterest: Array.isArray(row.LokasiInterest) ? row.LokasiInterest : [],
      Notes: row.Notes ?? "",

      // “next step”
      grade: row.inqGrade ?? "",
      isDropped: false,
      Sales: row.Sales ?? "",
      followUpDate: now,
      AdCode: row.AdCode ?? "",
      managementNotes: row.management?.fu?.[0]?.MGMTNotes ?? "",
    };

    setFormData(newForm);
    setBackupData({
      InqDate: inqDateVal,
      Nama: newForm.Nama,
      Iklan: newForm.Iklan,
      Phone: newForm.Phone,
      ProdukInterest: [...newForm.ProdukInterest],
      LokasiInterest: [...newForm.LokasiInterest],
      Notes: newForm.Notes,
    });

    setEditMode(false);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
    setFormData({});
    setBackupData({});
    setEditMode(false);
  };

  // Edit toggling for “previous data”
  const handleEdit = () => setEditMode(true);

  const handleDoneEdit = () => {
    // apply changes => do nothing special, just end edit
    setEditMode(false);
  };

  const handleCancelEdit = () => {
    // revert from backup
    setFormData((prev) => ({
      ...prev,
      InqDate: backupData.InqDate,
      Nama: backupData.Nama,
      Iklan: backupData.Iklan,
      Phone: backupData.Phone,
      ProdukInterest: [...backupData.ProdukInterest],
      LokasiInterest: [...backupData.LokasiInterest],
      Notes: backupData.Notes,
    }));
    setEditMode(false);
  };

  // handleFieldChange updates the entire form
  const handleFieldChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // When user clicks a grade card
  const handleGradeClick = (gradeId) => {
    setFormData(prev => ({ ...prev, grade: gradeId }));
  };

  // final save to server
  const handleSave = async () => {
    if (!selectedRowId) return;
  
    // Convert InqDate to ISO if valid
    let isoInqDate = null;
    if (formData.InqDate instanceof Date && !isNaN(formData.InqDate)) {
      isoInqDate = formData.InqDate.toISOString();
    }
  
    // Convert followUpDate to ISO if not dropped
    let isoFollowUp = null;
    if (!formData.isDropped && formData.followUpDate instanceof Date && !isNaN(formData.followUpDate)) {
      isoFollowUp = formData.followUpDate.toISOString();
    }
  
    // Determine the inqScore from the grade
    let chosenScore = 0;
    const foundGrade = gradeOptions.find((g) => g.id === formData.grade);
    if (foundGrade) chosenScore = foundGrade.score;
  
    // If dropped => no sales
    const finalSales = formData.isDropped ? "" : formData.Sales;
  
    // Build payload
    const payload = {
      id: selectedRowId,
      // previous data
      InqDate: isoInqDate,
      Nama: formData.Nama,
      Iklan: formData.Iklan,
      Phone: formData.Phone,
      ProdukInterest: formData.ProdukInterest,
      LokasiInterest: formData.LokasiInterest,
      Notes: formData.Notes,
  
      // next step
      inqGrade: formData.grade,
      inqScore: chosenScore,
      isDropped: formData.isDropped,
      Sales: finalSales,
      followUpDate: isoFollowUp,
      AdCode: formData.AdCode,
      managementNotes: formData.managementNotes,
      urgentstat: formData.urgent,
    };
  
    try {
      const res = await updateStage1(payload);
      if (res.success) {
        console.log(res.data)
        const updatedDoc = res.data;
        // update local table
        setInquiries((prev) =>
          prev.map((item) => (item._id === updatedDoc._id ? updatedDoc : item))
        );
        handleCloseDialog();
      } else {
        console.error("Server responded with error:", res.error);
      }
    } catch (err) {
      console.error("Error saving stage1:", err);
    }
  };
  
  

  // Render read-only version of “previous data”
  const renderPreviousDataReadOnly = () => (
    <Box sx={{ ml: 1 }}>
      <Typography variant="subtitle2" sx={{ mt: 2 }}>Inquiry Date</Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        {formData.InqDate ? formData.InqDate.toLocaleString() : "N/A"}
      </Typography>

      <Typography variant="subtitle2">Name</Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        {formData.Nama || "N/A"}
      </Typography>

      <Typography variant="subtitle2">From (Iklan)</Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        {formData.Iklan || "N/A"}
      </Typography>

      <Typography variant="subtitle2">Phone</Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        {formData.Phone || "N/A"}
      </Typography>

      <Typography variant="subtitle2">Produk Interest</Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        {Array.isArray(formData.ProdukInterest) && formData.ProdukInterest.length > 0
          ? formData.ProdukInterest.join(', ')
          : "N/A"}
      </Typography>

      <Typography variant="subtitle2">Lokasi Interest</Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        {Array.isArray(formData.LokasiInterest) && formData.LokasiInterest.length > 0
          ? formData.LokasiInterest.join(', ')
          : "N/A"}
      </Typography>

      <Typography variant="subtitle2">Notes</Typography>
      <Typography variant="body1">
        {formData.Notes || "N/A"}
      </Typography>
    </Box>
  );

  // Render editable version of “previous data”
  const renderPreviousDataEdit = () => (
    <Box sx={{ mb: 2 }}>
      {/* Inquiry Date */}
      <Typography variant="subtitle2" sx={{ mt: 2 }}>Inquiry Date</Typography>
      <DesktopDateTimePicker
        value={formData.InqDate || null}
        onChange={(newVal) => handleFieldChange("InqDate", newVal)}
        renderInput={(params) => <TextField fullWidth sx={{ mb: 2 }} {...params} />}
      />

      {/* Name */}
      <Typography variant="subtitle2">Name</Typography>
      <TextField
        fullWidth
        sx={{ mb: 2 }}
        value={formData.Nama || ""}
        onChange={(e) => handleFieldChange("Nama", e.target.value)}
      />

      {/* Iklan */}
      <Typography variant="subtitle2">From (Iklan)</Typography>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Ad Source</InputLabel>
        <Select
          value={formData.Iklan || ""}
          label="Ad Source"
          onChange={(e) => handleFieldChange("Iklan", e.target.value)}
        >
          {names.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Phone */}
      <Typography variant="subtitle2">Phone</Typography>
      <TextField
        fullWidth
        sx={{ mb: 2 }}
        value={formData.Phone || ""}
        onChange={(e) => handleFieldChange("Phone", e.target.value)}
      />

      {/* Produk Interest */}
      <Typography variant="subtitle2">Produk Interest</Typography>
      <Autocomplete
        multiple
        options={produk}
        // Force an array
        value={Array.isArray(formData.ProdukInterest) ? formData.ProdukInterest : []}
        onChange={(event, newVal) => handleFieldChange("ProdukInterest", newVal)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Produk"
            sx={{ mb: 2, mt: 1 }}
          />
        )}
      />

      {/* Lokasi Interest */}
      <Typography variant="subtitle2">Lokasi Interest</Typography>
      <Autocomplete
        multiple
        options={lokasi}
        // Force an array
        value={Array.isArray(formData.LokasiInterest) ? formData.LokasiInterest : []}
        onChange={(event, newVal) => handleFieldChange("LokasiInterest", newVal)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Lokasi"
            sx={{ mb: 2, mt: 1 }}
          />
        )}
      />

      {/* Notes */}
      <Typography variant="subtitle2">Notes</Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        sx={{ mb: 2 }}
        value={formData.Notes || ""}
        onChange={(e) => handleFieldChange("Notes", e.target.value)}
      />
    </Box>
  );
// New Inquiry Broadcast state ///////
const [openNewInquiryDialog, setOpenNewInquiryDialog] = useState(false);
const [newInquiryData, setNewInquiryData] = useState({
  inquiryDate: new Date(),
  Phone: "",
  AdCode: "",
  managementNotes: "",
  Sales: "",
  Nama:"",
});

const handleNewInquiryFieldChange = (field, value) => {
  setNewInquiryData((prev) => ({ ...prev, [field]: value }));
};

const handleNewInquirySave = async () => {
  const payload2 = {
    inquiryDate:
      newInquiryData.inquiryDate instanceof Date && !isNaN(newInquiryData.inquiryDate)
        ? newInquiryData.inquiryDate.toISOString()
        : newInquiryData.inquiryDate,
    Phone: newInquiryData.Phone,
    AdCode: newInquiryData.AdCode,
    managementNotes: newInquiryData.managementNotes,
    Sales: newInquiryData.Sales,
    Nama: newInquiryData.Nama,
  };
  try {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/newinquirybroadcast`, payload2);
    if (res.data.success) {
      console.log("New inquiry broadcast successful");
      setOpenNewInquiryDialog(false);
      // Optionally refresh your inquiry list or show a success notification here.
    } else {
      console.error("Error broadcasting new inquiry:", res.data.error);
    }
  } catch (err) {
    console.error("Error broadcasting new inquiry:", err);
  }
};
  return (
    <Grid container>
      {/* Left Menu */}
      <Grid item xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
        <LeftMenu />
      </Grid>

      {/* Main content */}
      <Grid item xs={12} sm={8.8} md={11.1} lg={11.3} xl={11.5} sx={{ p: 2 }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
  <Dialog
    open={openNewInquiryDialog}
    onClose={() => setOpenNewInquiryDialog(false)}
    fullWidth
    maxWidth="sm"
  >
    <DialogTitle>New Inquiry Broadcast</DialogTitle>
    <DialogContent dividers>
      <Typography variant="subtitle2" sx={{ mt: 2 }}>Inquiry Date</Typography>
      <DesktopDateTimePicker
        value={newInquiryData.inquiryDate || null}
        onChange={(newVal) => handleNewInquiryFieldChange("inquiryDate", newVal)}
        renderInput={(params) => <TextField fullWidth sx={{ mb: 2 }} {...params} />}
      />
      <Typography variant="subtitle2" sx={{ mt: 2 }}>Name</Typography>
      <TextField
        fullWidth
        sx={{ mb: 2 }}
        value={newInquiryData.Nama}
        onChange={(e) => handleNewInquiryFieldChange("Nama", e.target.value)}
      />
      <Typography variant="subtitle2">Phone</Typography>
      <TextField
        fullWidth
        sx={{ mb: 2 }}
        value={newInquiryData.Phone}
        onChange={(e) => handleNewInquiryFieldChange("Phone", e.target.value)}
      />
      <Typography variant="subtitle2" sx={{ mt: 2 }}>Ad Code</Typography>
      <Autocomplete
        freeSolo
        options={adCodes}
        value={newInquiryData.AdCode}
        onChange={(event, newVal) => handleNewInquiryFieldChange("AdCode", newVal)}
        onInputChange={(event, newVal) => handleNewInquiryFieldChange("AdCode", newVal)}
        renderInput={(params) => <TextField {...params} label="Ad Code" sx={{ mb: 2 }} />}
      />
      <Typography variant="subtitle2">Assign to Sales</Typography>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Sales</InputLabel>
        <Select
          value={newInquiryData.Sales}
          label="Sales"
          onChange={(e) => handleNewInquiryFieldChange("Sales", e.target.value)}
        >
          {salesList.map((s) => (
            <MenuItem key={s} value={s}>
              {s} ({salesCounts[s] || 0})
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography variant="subtitle2">Management Notes</Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        sx={{ mb: 2 }}
        value={newInquiryData.managementNotes}
        onChange={(e) => handleNewInquiryFieldChange("managementNotes", e.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setOpenNewInquiryDialog(false)}>Cancel</Button>
      <Button variant="contained" color="primary" onClick={handleNewInquirySave}>
        Broadcast
      </Button>
    </DialogActions>
  </Dialog>
</LocalizationProvider>

        <Typography variant="h5" gutterBottom>
          Sales Manager Dashboard Stage 1 (New Inquiry Distribution)
        </Typography>
        <Box sx={{ mb: 2 }}>
        <Button variant="contained" color="primary" onClick={() => setOpenNewInquiryDialog(true)}>
          New Inquiry Broadcast
        </Button>
      </Box>

        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><b>Inquiry Date</b></TableCell>
                  <TableCell><b>Name</b></TableCell>
                  <TableCell><b>From (Iklan)</b></TableCell>
                  <TableCell><b>Phone</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inquiries.length > 0 ? (
                  inquiries.map((row) => (
                    <TableRow
                      key={row._id}
                      hover
                      style={{ cursor: 'pointer', ...getRowStyle(row) }}
                      onClick={() => handleRowClick(row)}
                    >
                      <TableCell>{formatDisplayDate(row.InqDate)}</TableCell>
                      <TableCell>{getName(row)}</TableCell>
                      <TableCell>{getIklan(row)}</TableCell>
                      <TableCell>{getPhone(row)}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No Inquiries
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>Edit Inquiry</DialogTitle>
            <DialogContent dividers>
              {/* ========== PREVIOUS DATA SECTION ========== */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ my: 1 }}>
                  Previous Data
                </Typography>
                {!editMode ? (
                  <Button variant="outlined" onClick={() => setEditMode(true)}>
                    Edit
                  </Button>
                ) : (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        // user finalizes the local changes
                        setEditMode(false);
                      }}
                    >
                      Done Edit
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        // revert from backup
                        setFormData((prev) => ({
                          ...prev,
                          InqDate: backupData.InqDate,
                          Nama: backupData.Nama,
                          Iklan: backupData.Iklan,
                          Phone: backupData.Phone,
                          ProdukInterest: [...backupData.ProdukInterest],
                          LokasiInterest: [...backupData.LokasiInterest],
                          Notes: backupData.Notes,
                        }));
                        setEditMode(false);
                      }}
                    >
                      Cancel Edit
                    </Button>
                  </Box>
                )}
              </Box>

              {!editMode ? renderPreviousDataReadOnly() : renderPreviousDataEdit()}

              {/* Divider + Next Step */}
              <Divider sx={{ my: 3 }}>
                <Chip label="Next Step" />
              </Divider>

              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Grade this Inquiry
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
                {gradeOptions.map((option) => {
                  const isSelected = formData.grade === option.id;
                  return (
                    <Box
                      key={option.id}
                      onClick={() => handleGradeClick(option.id)}
                      sx={{
                        border: isSelected ? '2px solid #1976d2' : '1px solid #ccc',
                        borderRadius: 2,
                        padding: 2,
                        cursor: 'pointer',
                        width: 140,
                        textAlign: 'center'
                      }}
                    >
                      <Typography variant="h3" component="div">
                        {option.emoji}
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        {option.text}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>

              <Typography variant="subtitle1">Action</Typography>
              <RadioGroup
                row
                value={formData.isDropped ? "drop" : "follow"}
                onChange={(e) => handleFieldChange("isDropped", e.target.value === "drop")}
                sx={{ mb: 2 }}
              >
                <FormControlLabel
                  value="follow"
                  control={<Radio />}
                  label="Follow Up"
                />
                <FormControlLabel
                  value="drop"
                  control={<Radio />}
                  label="Drop"
                />
              </RadioGroup>

              {!formData.isDropped && (
                <>
                  <Typography variant="subtitle2">Assign to Sales:</Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                    <FormControl fullWidth>
                      <InputLabel>Sales</InputLabel>
                      <Select
                        value={formData.Sales || ""}
                        label="Sales"
                        onChange={(e) => handleFieldChange("Sales", e.target.value)}
                      >
                        {salesList.map((s) => (
                          <MenuItem key={s} value={s}>
                            {s} ({salesCounts[s] || 0})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Button
                      variant="outlined"
                      onClick={() => {
                        // 1) Generate a discrete random value in {0.0, 0.1, ..., 0.9}
                        const discreteRandom = Math.floor(Math.random() * 10) / 10;
                        // 2) If < 0.1 then 10% chance for "Sales1"
                        if (discreteRandom < 0.1) {
                          handleFieldChange("Sales", "Sales1");
                          console.log(discreteRandom);
                        } else {
                          console.log(discreteRandom);
                          const others = salesList.filter(s => s !== "Sales1");
                          const randomIndex = Math.floor(Math.random() * others.length);
                          handleFieldChange("Sales", others[randomIndex]);
                        }
                      }}
                    >
                      Random
                    </Button>
                  </Box>

                  <Typography variant="subtitle2">Follow Up Date:</Typography>
                  <DesktopDateTimePicker
                    value={formData.followUpDate}
                    onChange={(newVal) => handleFieldChange("followUpDate", newVal)}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        sx={{ mb: 2 }}
                        {...params}
                      />
                    )}
                  />
                </>
              )}

              <Typography variant="subtitle2">Ad Code:</Typography>
              <Autocomplete
                freeSolo
                options={adCodes}
                value={formData.AdCode || ""}
                onChange={(event, newVal) => handleFieldChange("AdCode", newVal)}
                onInputChange={(event, newVal) => handleFieldChange("AdCode", newVal)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Ad Code"
                    sx={{ mb: 2, mt: 1 }}
                  />
                )}
              />

              {/* New Urgent Checkbox */}
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.urgent || false}
                      onChange={(e) => handleFieldChange("urgent", e.target.checked)}
                    />
                  }
                  label="Urgent?"
                />
              </Box>

              <Typography variant="subtitle2">Management Notes:</Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                value={formData.managementNotes || ""}
                onChange={(e) => handleFieldChange("managementNotes", e.target.value)}
                sx={{ mb: 2, mt: 1 }}
              />
            </DialogContent>

            <DialogActions>
              <Button onClick={handleCloseDialog}>Cancel</Button>
              <Button variant="contained" color="primary" onClick={handleSave}>
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
}
